export const itemPadding = '20px'
export const smallMobile = '512px'
export const mobile = '768px'
export const tablet = '769px'
export const desktop = '1024px'
export const color_red = '#ea0001'
export const btn_color = '#795548'
